import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageSEO } from '../config/seoConfig';

/**
 * SEOHead — sets <html lang> on every route change.
 * Place once in App.tsx inside <BrowserRouter>.
 *
 * Canonical and hreflang are handled by useSEO (called via usePageSEO
 * in PageSEOHead) — NOT duplicated here to avoid conflicts.
 */

function detectLang(pathname: string): string {
    if (pathname.startsWith('/es/') || pathname === '/es') return 'es';
    if (pathname.startsWith('/fr/') || pathname === '/fr') return 'fr';
    return 'en';
}

export function SEOHead(): null {
    const { pathname } = useLocation();

    useEffect(() => {
        document.documentElement.lang = detectLang(pathname);
    }, [pathname]);

    return null;
}

/**
 * PageSEOHead — per-page SEO component.
 * Accepts a `page` key that maps to seoConfig.ts registry.
 * Sets title, description, canonical, hreflang, og tags, schema.org.
 *
 * Usage: <PageSEOHead page="calculator" />
 */
export function PageSEOHead({ page }: { page: string }): null {
    usePageSEO(page);
    return null;
}

export default SEOHead;
